/**
 * Swagger: https://api-dev.oneclass.co/teacher/api/docs/#/
 */
import { AxiosInstance } from 'axios';
import schedules from './schedules';

export default (axios: AxiosInstance, apiPrefix: string) => ({
  schedules: schedules(axios, apiPrefix),
});
